import { configureStore } from '@reduxjs/toolkit';

import { baseApi } from './api/base';
import { accountSlice } from './slices/account';
import { authSlice } from './slices/auth';
import { errorSlice } from './slices/error';
import { inventorySlice } from './slices/inventory';
import { layoutSlice } from './slices/layout';

export const rootReducer = {
  auth: authSlice.reducer,
  inventory: inventorySlice.reducer,
  account: accountSlice.reducer,
  layout: layoutSlice.reducer,
  error: errorSlice.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

export default store;
